import React, { Component } from 'react';

export default class Contact extends Component {
	render() {
		return (
			<h1>Contact</h1>
		)
	}
}


// WEBPACK FOOTER //
// ./src/Layouts/Contact.js